import * as React from 'react'

import {
  CheckBoxInput,
  ModalRow,
  ModalRowField,
  ModalFieldHeader,
  ModalFieldValue,
  Divider
} from './Styles'

type InputProps = {
  caseName: string
  getUseDefaults: () => boolean
  setUseDefaults: (use: boolean) => void
}

export default class ConfirmCase extends React.Component<InputProps> {
  checkChanged = event => {
    this.props.setUseDefaults(event.currentTarget.checked)
  }

  render() {
    const { caseName, getUseDefaults } = this.props
    const checked = getUseDefaults()
    return (
      <Divider>
        <ModalRow>
          <ModalRowField>
            <CheckBoxInput
              name={caseName}
              onChange={this.checkChanged}
              type="checkbox"
              placeholder=""
              required={false}
              checked={checked}
            />
          </ModalRowField>
          <ModalRowField>
            <ModalFieldHeader>Case</ModalFieldHeader>
            <ModalFieldValue>{caseName}</ModalFieldValue>
          </ModalRowField>
        </ModalRow>
      </Divider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Components/Projects/ConfirmCase.tsx